import React, {useState, useRef} from 'react';

import DatePicker from './DatePicker';
import useOutsideClick from '../../../../../../../../hooks/use-outside-click';
import * as S from './DatePicker.styles';

const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

const DateRangePicker = ({
  startLabel,
  endLabel,
  singleDate = true,
  startValue,
  changeHandler,
  name,
  mode,
  from,
  to,
  setFrom,
  setTo,
  isMandatory = true,
  errorMessage = '',
  hidePreviousDate = false,
  endDate,
}) => {
  const ref = useRef();

  const [searchStep, setSerachStep] = useState('');
  const [selectTab, setSelectTab] = useState(0);

  const handleSearchStep = id => {
    setSerachStep(id);
  };

  const handleSelectTab = index => {
    setSelectTab(index);
  };

  useOutsideClick(ref, () => {
    setSerachStep(null);
  });

  const useViewport = () => {
    const [width, setWidth] = useState(window.innerWidth);
    React.useEffect(() => {
      const handleWindowResize = () => setWidth(window.innerWidth);
      window.addEventListener('resize', handleWindowResize);
      return () => window.removeEventListener('resize', handleWindowResize);
    }, []);
    return {width};
  };
  const {width} = useViewport();
  const breakpoint = 766;

  const getFromDate = () => {
    if (from) {
      return `${days[from.getDay()]}, ${from.getDate()} ${
        months[from.getMonth()]
      } ${from.getFullYear() % 2000}`;
    }

    return `Select ${startLabel}`;
  };
  const getToDate = () => {
    if (to) {
      return `${days[to.getDay()]}, ${to.getDate()} ${months[to.getMonth()]} ${to.getFullYear() %
        2000}`;
    }

    return `Select ${endLabel}`;
  };

  return (
    <S.Conitaner>
      <div className="fieldWrap" ref={ref}>
        <div className="trvlDateField" onClick={() => handleSearchStep('Dates')}>
          {width < breakpoint && (
            <span className="iconHolder">
              <span className="sprite dateCalIcon"></span>
            </span>
          )}
          <div className="startDate dayPickerInputBox">
            <p className="labelText">
              {startLabel}
              {isMandatory ? <span>*</span> : null}
            </p>
            <span className="inputContainer">
              <input
                readOnly
                type="text"
                value={startValue || getFromDate()}
                name={name}
                placeholder={startLabel}
              />
              <i className="arrow down" />
            </span>
          </div>
          {!singleDate && (
            <div className="endDate dayPickerInputBox">
              {width < breakpoint ? (
                <p className="addRtnDate">+ADD RETURN DATE</p>
              ) : (
                <>
                  <p className="labelText">
                    {endLabel}
                    {isMandatory ? <span>*</span> : null}
                  </p>
                  <span className="inputContainer">
                    <input readOnly type="text" value={getToDate()} />
                    <i className="arrow down" />
                  </span>
                </>
              )}
            </div>
          )}
        </div>
        {searchStep === 'Dates' && (
          <>
            <DatePicker
              width={width}
              breakpoint={breakpoint}
              handleSearchStep={handleSearchStep}
              selectTab={selectTab}
              handleSelectTab={handleSelectTab}
              endDateLabel={endLabel}
              startDateLabel={startLabel}
              from={from}
              to={to}
              setFrom={setFrom}
              setTo={setTo}
              singleDate={singleDate}
              changeHandler={changeHandler}
              name={name}
              mode={mode}
              hidePreviousDate={hidePreviousDate}
              endDate={endDate}
            />
          </>
        )}
        {errorMessage && <S.Error>{errorMessage}</S.Error>}
      </div>
    </S.Conitaner>
  );
};

export default DateRangePicker;
